<form [formGroup]="form" (ngSubmit)="onSubmit()" class="login-container w-full">
    <div class="flex h-full gap-10 w-full flex-col xl:flex-row">
        <div class="w-full flex flex-col">
            <div class="w-full bg-white rounded-xl h-full">
                <div class="flex p-4 space-x-2 items-center">
                    <div class="h-8 w-[4px] bg-primary"></div>
                    <span> Material</span>
                </div>

                <div class="p-4 flex flex-col gap-4">
                  <div>
                        <mat-label>Road Type *</mat-label>

                    <mat-form-field  appearance="outline" class="w-full">
                        <mat-select [(ngModel)]="roadTypeName" formControlName="typeofRoad" name="typeofRoad" required>
                            <mat-option value="" disabled>Select Road Type</mat-option>
                            <mat-option *ngFor="let road of roadTypes" [value]="road">
                                {{ road }}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="form.get('typeofRoad')?.invalid && form.get('typeofRoad')?.touched">
                            Road Type is required.
                        </mat-error>
                    </mat-form-field>
                    </div>

                    <!-- Checkboxes -->
                    <div class="flex flex-col gap-2" *ngIf="roadTypeName">
                        <div formArrayName="constructionSteps" class="space-y-2">
                          <div *ngFor="let group of constructionStepsFormArray.controls; let i = index"
                            [formGroupName]="i">
                            <mat-card class="border rounded shadow-sm">
                              <mat-expansion-panel [(expanded)]="expandedStates[i]">
                                <mat-expansion-panel-header>
                                  <mat-panel-title>
                                    <strong>{{ group.get('label')?.value }}</strong>
                                  </mat-panel-title>
                                  <mat-icon>{{ expandedStates[i] ? 'expand_less' : 'expand_more' }}</mat-icon>
                                </mat-expansion-panel-header>
                                <div *ngIf="expandedStates[i]" class="p-4">
                                  <mat-form-field appearance="outline" class="w-full">
                                    <input matInput formControlName="value" [placeholder]="group.get('label')?.value">
                                    <mat-error *ngIf="group.get('value')?.invalid && group.get('value')?.touched">
                                      This field is required.
                                    </mat-error>
                                  </mat-form-field>
                                </div>
                              </mat-expansion-panel>
                            </mat-card>
                          </div>
                        </div>
                      </div>
                      

                    <!-- <div class="flex flex-col gap-2" *ngIf="roadTypeName">

                        <div formArrayName="constructionSteps" class="space-y-2">
                            <div *ngFor="let group of constructionStepsFormArray.controls; let i = index"
                                [formGroupName]="i">
                                <div class="border rounded shadow-sm">
                                    <div class="bg-gray-100 px-4 py-2 cursor-pointer"
                                        (click)="expandedStates[i] = !expandedStates[i]">
                                        <strong>{{ group.get('label')?.value }}</strong>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" style="float: inline-end;">
                                            <g clip-path="url(#clip0)">
                                                <path
                                                    d="M7.41 8.58984L12 13.1698L16.59 8.58984L18 9.99984L12 15.9998L6 9.99984L7.41 8.58984Z"
                                                    fill="#6C757D" />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0">
                                                    <rect width="24" height="24" fill="white" />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </div>
                                    <div *ngIf="expandedStates[i]" class="p-4">
                                        <input type="text" formControlName="value"
                                            [placeholder]="group.get('label')?.value"
                                            class="w-full border p-2 rounded-md outline-none" />
                                        <div *ngIf="group.get('value')?.invalid && group.get('value')?.touched"
                                            class="text-red-500 text-sm">
                                            This field is required.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> -->



                    <!-- <div class="flex flex-col gap-2" *ngIf="roadTypeName === 'Asphalt Road'">

                        <div formArrayName="constructionSteps" class="space-y-2">
                            <div *ngFor="let group of constructionStepsFormArray.controls; let i = index"
                                [formGroupName]="i">
                                <div class="border rounded shadow-sm">
                                    <div class="bg-gray-100 px-4 py-2 cursor-pointer"
                                        (click)="expandedStates[i] = !expandedStates[i]"> <strong>{{
                                            group.get('label')?.value }}</strong>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" style="float: inline-end;">
                                            <g clip-path="url(#clip0_1958_7961)">
                                                <path
                                                    d="M7.41 8.58984L12 13.1698L16.59 8.58984L18 9.99984L12 15.9998L6 9.99984L7.41 8.58984Z"
                                                    fill="#6C757D" />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_1958_7961">
                                                    <rect width="24" height="24" fill="white" />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </div>
                                    <div *ngIf="expandedStates[i]" class="p-4"> <input type="text"
                                            formControlName="value" placeholder="{{
                                            group.get('label')?.value }}"
                                            class="w-full border p-2 rounded-md outline-none" />
                                        <div *ngIf="group.get('value')?.invalid && group.get('value')?.touched"
                                            class="text-red-500 text-sm"> This field is required. </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="flex flex-col gap-2" *ngIf="roadTypeName === 'Concrete Road'">

                        <div formArrayName="constructionSteps" class="space-y-2">
                            <div *ngFor="let group of constructionStepsFormArray.controls; let i = index"
                                [formGroupName]="i">
                                <div class="border rounded shadow-sm">
                                    <div class="bg-gray-100 px-4 py-2 cursor-pointer"
                                        (click)="expandedStates[i] = !expandedStates[i]"> <strong>{{
                                            group.get('label')?.value }}</strong> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" style="float: inline-end;">
                                            <g clip-path="url(#clip0_1958_7961)">
                                                <path
                                                    d="M7.41 8.58984L12 13.1698L16.59 8.58984L18 9.99984L12 15.9998L6 9.99984L7.41 8.58984Z"
                                                    fill="#6C757D" />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_1958_7961">
                                                    <rect width="24" height="24" fill="white" />
                                                </clipPath>
                                            </defs>
                                        </svg></div>
                                    <div *ngIf="expandedStates[i]" class="p-4"> <input type="text"
                                            formControlName="value" placeholder="{{
                                            group.get('label')?.value }}"
                                            class="w-full border p-2 rounded-md outline-none" />
                                        <div *ngIf="group.get('value')?.invalid && group.get('value')?.touched"
                                            class="text-red-500 text-sm"> This field is required. </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="flex flex-col gap-2" *ngIf="roadTypeName === 'Gravel Road'">

                        <div formArrayName="constructionSteps" class="space-y-2">
                            <div *ngFor="let group of constructionStepsFormArray.controls; let i = index"
                                [formGroupName]="i">
                                <div class="border rounded shadow-sm">
                                    <div class="bg-gray-100 px-4 py-2 cursor-pointer"
                                        (click)="expandedStates[i] = !expandedStates[i]"> <strong>{{
                                            group.get('label')?.value }}</strong> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" style="float: inline-end;">
                                            <g clip-path="url(#clip0_1958_7961)">
                                                <path
                                                    d="M7.41 8.58984L12 13.1698L16.59 8.58984L18 9.99984L12 15.9998L6 9.99984L7.41 8.58984Z"
                                                    fill="#6C757D" />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_1958_7961">
                                                    <rect width="24" height="24" fill="white" />
                                                </clipPath>
                                            </defs>
                                        </svg></div>
                                    <div *ngIf="expandedStates[i]" class="p-4"> <input type="text"
                                            formControlName="value" placeholder="{{
                                            group.get('label')?.value }}"
                                            class="w-full border p-2 rounded-md outline-none" />
                                        <div *ngIf="group.get('value')?.invalid && group.get('value')?.touched"
                                            class="text-red-500 text-sm"> This field is required. </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="flex flex-col gap-2" *ngIf="roadTypeName === 'Paver Block Road'">

                        <div formArrayName="constructionSteps" class="space-y-2">
                            <div *ngFor="let group of constructionStepsFormArray.controls; let i = index"
                                [formGroupName]="i">
                                <div class="border rounded shadow-sm">
                                    <div class="bg-gray-100 px-4 py-2 cursor-pointer"
                                        (click)="expandedStates[i] = !expandedStates[i]"> <strong>{{
                                            group.get('label')?.value }}</strong> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" style="float: inline-end;">
                                            <g clip-path="url(#clip0_1958_7961)">
                                                <path
                                                    d="M7.41 8.58984L12 13.1698L16.59 8.58984L18 9.99984L12 15.9998L6 9.99984L7.41 8.58984Z"
                                                    fill="#6C757D" />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_1958_7961">
                                                    <rect width="24" height="24" fill="white" />
                                                </clipPath>
                                            </defs>
                                        </svg></div>
                                    <div *ngIf="expandedStates[i]" class="p-4"> <input type="text"
                                            formControlName="value" placeholder="{{
                                            group.get('label')?.value }}"
                                            class="w-full border p-2 rounded-md outline-none" />
                                        <div *ngIf="group.get('value')?.invalid && group.get('value')?.touched"
                                            class="text-red-500 text-sm"> This field is required. </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="flex flex-col gap-2" *ngIf="roadTypeName === 'Bituminous Road'">

                        <div formArrayName="constructionSteps" class="space-y-2">
                            <div *ngFor="let group of constructionStepsFormArray.controls; let i = index"
                                [formGroupName]="i">
                                <div class="border rounded shadow-sm">
                                    <div class="bg-gray-100 px-4 py-2 cursor-pointer"
                                        (click)="expandedStates[i] = !expandedStates[i]"> <strong>{{
                                            group.get('label')?.value }}</strong><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" style="float: inline-end;">
                                            <g clip-path="url(#clip0_1958_7961)">
                                                <path
                                                    d="M7.41 8.58984L12 13.1698L16.59 8.58984L18 9.99984L12 15.9998L6 9.99984L7.41 8.58984Z"
                                                    fill="#6C757D" />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_1958_7961">
                                                    <rect width="24" height="24" fill="white" />
                                                </clipPath>
                                            </defs>
                                        </svg> </div>
                                    <div *ngIf="expandedStates[i]" class="p-4"> <input type="text"
                                            formControlName="value" placeholder="{{
                                            group.get('label')?.value }}"
                                            class="w-full border p-2 rounded-md outline-none" />
                                        <div *ngIf="group.get('value')?.invalid && group.get('value')?.touched"
                                            class="text-red-500 text-sm"> This field is required. </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="flex flex-col gap-2" *ngIf="roadTypeName === 'Dirt Road'">

                        <div formArrayName="constructionSteps" class="space-y-2">
                            <div *ngFor="let group of constructionStepsFormArray.controls; let i = index"
                                [formGroupName]="i">
                                <div class="border rounded shadow-sm">
                                    <div class="bg-gray-100 px-4 py-2 cursor-pointer"
                                        (click)="expandedStates[i] = !expandedStates[i]"> <strong>{{
                                            group.get('label')?.value }}</strong> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" style="float: inline-end;">
                                            <g clip-path="url(#clip0_1958_7961)">
                                                <path
                                                    d="M7.41 8.58984L12 13.1698L16.59 8.58984L18 9.99984L12 15.9998L6 9.99984L7.41 8.58984Z"
                                                    fill="#6C757D" />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_1958_7961">
                                                    <rect width="24" height="24" fill="white" />
                                                </clipPath>
                                            </defs>
                                        </svg></div>
                                    <div *ngIf="expandedStates[i]" class="p-4"> <input type="text"
                                            formControlName="value" placeholder="{{
                                            group.get('label')?.value }}"
                                            class="w-full border p-2 rounded-md outline-none" />
                                        <div *ngIf="group.get('value')?.invalid && group.get('value')?.touched"
                                            class="text-red-500 text-sm"> This field is required. </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="flex flex-col gap-2" *ngIf="roadTypeName === 'Cycle Path/Footpath'">

                        <div formArrayName="constructionSteps" class="space-y-2">
                            <div *ngFor="let group of constructionStepsFormArray.controls; let i = index"
                                [formGroupName]="i">
                                <div class="border rounded shadow-sm">
                                    <div class="bg-gray-100 px-4 py-2 cursor-pointer"
                                        (click)="expandedStates[i] = !expandedStates[i]"> <strong>{{
                                            group.get('label')?.value }}</strong><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                            viewBox="0 0 24 24" fill="none" style="float: inline-end;">
                                            <g clip-path="url(#clip0_1958_7961)">
                                                <path
                                                    d="M7.41 8.58984L12 13.1698L16.59 8.58984L18 9.99984L12 15.9998L6 9.99984L7.41 8.58984Z"
                                                    fill="#6C757D" />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_1958_7961">
                                                    <rect width="24" height="24" fill="white" />
                                                </clipPath>
                                            </defs>
                                        </svg> </div>
                                    <div *ngIf="expandedStates[i]" class="p-4"> <input type="text"
                                            formControlName="value" placeholder="{{
                                            group.get('label')?.value }}"
                                            class="w-full border p-2 rounded-md outline-none" />
                                        <div *ngIf="group.get('value')?.invalid && group.get('value')?.touched"
                                            class="text-red-500 text-sm"> This field is required. </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> -->

                    <!--Input -->
                    <!-- Materials Needed -->
                    <div class="flex flex-col gap-2">
                            <mat-label>Materials Needed *</mat-label>

                        <mat-form-field  appearance="outline" class="w-full">
                            <textarea matInput formControlName="materialsNeeded" placeholder="Materials Needed"
                                rows="3"></textarea>
                            <mat-error
                                *ngIf="form.get('materialsNeeded')?.invalid && form.get('materialsNeeded')?.touched">
                                Materials Needed is required.
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <!-- Machines/Equipment -->
                    <div class="flex flex-col gap-2">
                            <mat-label>Machines/Equipment *</mat-label>

                        <mat-form-field  appearance="outline" class="w-full">
                            <textarea matInput formControlName="machinesEquipment" placeholder="Machines/Equipment"
                                rows="3"></textarea>
                            <mat-error
                                *ngIf="form.get('machinesEquipment')?.invalid && form.get('machinesEquipment')?.touched">
                                Machines/Equipment is required.
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <!-- Basic Requirements -->
                    <div class="flex flex-col gap-2">
                            <mat-label>Basic Requirements *</mat-label>

                        <mat-form-field  appearance="outline" class="w-full">
                            <textarea matInput formControlName="basicRequirements" placeholder="Basic Requirements"
                                rows="3"></textarea>
                            <mat-error
                                *ngIf="form.get('basicRequirements')?.invalid && form.get('basicRequirements')?.touched">
                                Basic Requirements is required.
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <!-- Per Lane Dimension -->
                    <div class="flex flex-col gap-2">
                            <mat-label>Per Lane Dimension *</mat-label>

                        <mat-form-field  appearance="outline" class="w-full">
                            <input matInput formControlName="perLaneDimension" placeholder="Per Lane Dimension" />
                            <mat-error
                                *ngIf="form.get('perLaneDimension')?.invalid && form.get('perLaneDimension')?.touched">
                                Per Lane Dimension is required.
                            </mat-error>
                        </mat-form-field>
                    </div>

                </div>
            </div>
        </div>
    </div>
</form>
<div class="w-full flex items-center justify-end" style="margin-top: 10px;">
    <button (click)="onSubmit()" class="rounded-xl p-3 w-60 text-white bg-primary">
        Save
    </button>
</div>